import { Field } from '@progress/kendo-react-form';
import React from 'react'; 
import {CusFormLabel} from '../validation/Form-Components';
import personDtlsData from '../data/persondetailsdata.json';
import helper from '../factory/Helper';
import nationalitycodes from '../data/nationality.json';
import genders from '../data/gender.json';
import residentialcodes from '../data/residentialcode.json';
import myInfoApiCountries from '../data/myInfoApiCountryList.json';
 
const MyInfoPersonDetails = (props) => {

    const{ personDetails, order ,fProps, ...oth} = props;
    
    const getIDNum = () => {
        if(personDetails.allowEdit) {
            return personDetails.myInfo.IDNumber;
        }
        return helper.mask(personDetails.myInfo.IDNumber,4);
    }

    return(
        <div>
            <Field component={CusFormLabel} 
                leftLabelId={'lblHanPinName'} leftLabelName={personDtlsData.label.hanPinName} 
                id={'hanPinName'} name={personDetails.myInfo.HANYU_PINYIN_NAME !==null? personDetails.myInfo.HANYU_PINYIN_NAME:''} />

            <Field component={CusFormLabel} 
                leftLabelId={'lblAliasName'} leftLabelName={personDtlsData.label.aliName} 
                id={'aliasName'} name={personDetails.myInfo.ALIAS_NAME !==null? personDetails.myInfo.ALIAS_NAME:''} />

            <Field component={CusFormLabel} 
                leftLabelId={'lblHanyuAliasName'} leftLabelName={personDtlsData.label.hanPinAliName} 
                id={'hanyuAliasName'} name={personDetails.myInfo.HANYU_PINYIN_ALIAS_NAME !==null? personDetails.myInfo.HANYU_PINYIN_ALIAS_NAME:''} />

            <Field component={CusFormLabel} 
                leftLabelId={'lblmarName'} leftLabelName={personDtlsData.label.marName} 
                id={'marriedName'} name={personDetails.myInfo.MARRIED_NAME !==null? personDetails.myInfo.MARRIED_NAME:''} />

            <Field component={CusFormLabel} 
                leftLabelId={'lblIC'} leftLabelName={personDtlsData.label.ic} 
                id={'idNum'} name={getIDNum()} />

            <Field component={CusFormLabel} 
                leftLabelId={'lblGender'} leftLabelName={personDtlsData.label.gender} 
                id={'gender'} name={personDetails.myInfo.Gender && personDetails.myInfo.Gender !== null? helper.getObjInArray(personDetails.myInfo.Gender,genders).label:''} />
                            
            <Field component={CusFormLabel} 
                leftLabelId={'lblRace'} leftLabelName={personDtlsData.label.race} 
                id={'Race'} name={personDetails.myInfo.RACE_DESC && personDetails.myInfo.RACE_DESC !== null? personDetails.myInfo.RACE_DESC:''} />

            <Field component={CusFormLabel} 
                leftLabelId={'lblDOB'} leftLabelName={personDtlsData.label.dob} 
                id={'dob'} name={personDetails.myInfo.DATE_OF_BIRTH !==null? helper.formatDateDDMMYYYY(personDetails.myInfo.DATE_OF_BIRTH):''} />
                
            <Field component={CusFormLabel} 
                leftLabelId={'lblNationality'} leftLabelName={personDtlsData.label.nationality} 
                id={'nationality'} name={personDetails.myInfo.NATIONALITY && personDetails.myInfo.NATIONALITY !==null?  helper.getObjInArray(personDetails.myInfo.NATIONALITY,nationalitycodes).label:''} />

            <Field component={CusFormLabel} 
                leftLabelId={'lblCountryOfBirth'} leftLabelName={personDtlsData.label.countryOfBirth} 
                id={'countryOfBirth'} name={!personDetails.myInfo.COUNTRY_OF_BIRTH? '': personDetails.myInfo.COUNTRY_OF_BIRTH===null? '': helper.getObjInArray(personDetails.myInfo.COUNTRY_OF_BIRTH,myInfoApiCountries).label} />
                            
            <Field component={CusFormLabel}   
                leftLabelId={'lblResiStatus'} leftLabelName={personDtlsData.label.resiStatus} 
                id={'resiStatus'} name={!personDetails.myInfo.RESI_STS?'': personDetails.myInfo.RESI_STS === null? '': helper.getObjInArray(personDetails.myInfo.RESI_STS,residentialcodes).label} />

            <Field component={CusFormLabel} 
                leftLabelId={'lblDesignation'} leftLabelName={personDtlsData.label.designation} 
                id={'designation'} name={personDetails.myInfo.Position_Desc && personDetails.myInfo.Position_Desc !==null? personDetails.myInfo.Position_Desc :''} />
        </div>
    )
}

export default MyInfoPersonDetails;